import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
} from 'react-bootstrap';

import BidsetsTable from './BidsetsTable';
import BidsetsTableDetached from './BidsetsTableDetached';
import ManageBidsMenu from './ManageBidsMenu';

class ManageBids extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpdate: false,
    };
    this.handleRefreshRequest = this.handleRefreshRequest.bind(this);
    this.showUpdate = this.showUpdate.bind(this);
    this.closeUpdate = this.closeUpdate.bind(this);
  }
  componentWillMount() {
    if(this.props.needFetch) {
    	this.props.requestBidsets(this.props.tourId);
    }

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.tourId !== this.props.tourId) {
      this.props.requestBidsets(nextProps.tourId);
    } else if (nextProps.needFetch) {
      this.props.requestBidsets(nextProps.tourId);
    }
  }
  handleRefreshRequest(e) {
    this.props.requestBidsets(this.props.tourId);
  }
  closeUpdate() {
    this.setState({
      showUpdate: false,
    });
  }
  showUpdate(e) {
    e.preventDefault();
    this.setState({
      showUpdate: true,
    });
  }
  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return (<div>Loading...</div>);
    }
    if (this.props.bids.length !== 0) {
      return (
        <div>
          <ManageBidsMenu
            id={this.props.tour.id}
            bidFilterSet={this.props.bidFilterSet}
            downloadTourPdf={this.props.downloadTourPdf}
            filter={this.props.bidFilter}
            groups={this.props.tour.groups}
            isTourManager={this.props.isTourManager}
            messageSet={this.props.messageSet}
            readOnly={this.props.readOnly}
            sendToTourManager={this.props.sendToTourManager}
            setTourManagerSimMode={this.props.setTourManagerSimMode}
            showUpdate={this.showUpdate}
          />
          <BidsetsTable
            bids={this.props.bids}
            addBidNote={this.props.addBidNote}
            detail={this.props.detail}
            editBid={this.props.editBid}
            filter={this.props.bidFilter}
            isTourManager={this.props.isTourManager}
            readOnly={this.props.readOnly}
            removeBid={this.props.removeBid}
            sendBid={this.props.sendBid}
            user={this.props.user}
            showUpdate={this.state.showUpdate}
            sendBidUpdate={this.props.sendBidUpdate}
            closeUpdate={this.closeUpdate}
          />
        </div>
      );
    }
    return (
      <div>No bids are available. You must select hotels before managing bids.
        <Button onClick={this.handleRefreshRequest} bsStyle="primary">Refresh</Button>
      </div>
    );
  }
}

ManageBids.propTypes = {
  tourId: PropTypes.number.isRequired,
  addBidNote: PropTypes.func.isRequired,
  bidFilter: PropTypes.object.isRequired,
  bidFilterSet: PropTypes.func.isRequired,
  bids: PropTypes.arrayOf(PropTypes.object).isRequired,
  detail: PropTypes.string,
  editBid: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  needFetch: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  removeBid: PropTypes.func.isRequired,
  requestBidsets: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  sendBidUpdate: PropTypes.func.isRequired,
  sendToTourManager: PropTypes.func.isRequired,
};

ManageBids.defaultProps = {
  bids: [],
  detail: null,
};
export default ManageBids;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBids.js